module.exports = __webpack_public_path__ + "static/seal-1525c144d07be160df3d44431295621b.png";